import { axios } from "../config";

export const signIn = async (data) => {
  const res = await axios.post(`/auth/sign-in`, data);
  return res;
};

export const signUp = async (data) => {
  const res = await axios.post(`/auth/sign-up`, data);
  return res;
};

export const refreshToken = async (data) => {
  return axios.post(`/auth/refresh`, { token: data });
};

export const googleAuth = async (data) => {
  return axios.post(`/auth/google-login`, data);
};

export const facebookAuth = async (data) => {
  return axios.post(`/auth/facebook-login`, { token: data });
};

export const resendEmail = async (data) => {
  const res = await axios.post(`/auth/sign-up/resend-email`, {
    email: data,
  });
  return res;
};

export const verifyPhone = async (data) => {
  const res = await axios.post(`/auth/verify-phone`, {
    token: data,
  });
  return res;
};

export const verifyEmail = async (data) => {
  const res = await axios.post(`/auth/verify-email`, {
    token: data,
  });
  return res;
};

export const resendSms = async (data) => {
  const res = await axios.post(`/auth/sign-up/resend-sms`, {
    phone: data,
  });
  return res;
};

export const createOrder = async (data) => {
  const res = await axios.post(`/orders`, data);
  return res;
};

export const logOut = async () => {
  const res = await axios.get(`/auth/logout`);
  return res;
};

export const getUserData = async () => {
  const res = await axios.get(`/users/me`);
  return res;
};

export const getStudios = async () => {
  const res = await axios.get(`/studios`);
  return res;
};

export const getMasters = async (studioId) => {
  const res = await axios.get(`/masters`, {
    params: {
      studios: [studioId],
      limit: 100,
    },
  });
  return res;
};

export const getMasterAvailability = async ({ masterId, studioId, date }) => {
  const timeZone = Math.abs(new Date(date).getTimezoneOffset());
  const formatedDate = new Date(date + timeZone * 60 * 1000).toISOString().substr(0, 10);

  const res = await axios.get(`/masters/${masterId}/availability`, {
    params: {
      studioId: studioId,
      date: formatedDate,
    },
  });
  return res;
};

export const getServices = async (studioId, category) => {
  const res = await axios.get(`/studios/${studioId}/services`, {
    params: {
      category: category,
      limit: 500,
    },
  });
  return res;
};

export const updateUserData = async (data = {}) => {
  const res = await axios
    .patch(`/users/me`, {
      firstName: data.newData?.firstName,
      lastName: data.newData?.lastName,
    })
    .then(() => data);
  return res;
};

export const deleteUser = async () => {
  const res = await axios.delete(`/users/me`);
  return res;
};

export const getOrders = async () => {
  const res = await axios.get(`/orders`, {
    params: {
      limit: 500,
    },
  });
  return res;
};

export const deleteOrder = async (orderId) => {
  const res = await axios.post(`/orders/${orderId}/cancel`);
  return res;
};

export const payForOrder = async (orderId) => {
  const res = await axios.post(`/orders/${orderId}/pay`);
  return res;
};